import * as ComObj from "@/api/company";
import router from "@/router";
import { getIsAccessDisabled } from "@/utils/permissions";
import { contactDetailsPayload, isContactDetailsActive } from "@/utils/contactDetails";
import {
  withoutUnsupportedJobLocationOperators,
} from "@/views/search/search-common/location-filters";

export const getInitialFilterState = () => ({
  locations: new Map(),
  verticals: [],
  vertical_categories: [],
  categories: [],
  technologies: [],
  company_groups: [],
  companies: new Map(),
  social_media: [],
  contact_details: { types: [], exclude_without: false },
  company_name: "",
  employees: [],
  founded_dates: [],
  revenues: [],
  sequences: [],
  job_locations: new Map(),
  job_exclude_locations: new Map(),
  job_posted_dates: [],
  job_titles: [],
  exclude_job_titles: [],
  keywords: [],
  news_categories: [],
  news_published_dates: [],
  vertical_sub_categories: [],
  exclude_locations: new Map(),
  notReset: false,
  page: 1,
  per_page: parseInt(process.env.VUE_APP_PER_PAGE),

  // advertisement related filters
  advertisement_target_locations: new Map(),
  advertisement_exclude_target_locations: new Map(),
  advertisement_search_terms: [],
  advertisement_platforms: [],
  advertisement_status: [],
  advertisement_start_dates: [],
  advertisement_end_dates: [],

  places: [],
  exclude_places: [],

  filter_conditions: [
    {
      key: "technologies",
      operator: "or",
    },
    {
      key: "categories",
      operator: "or",
    },
    {
      key: "verticals",
      operator: "or",
    },
    {
      key: "vertical_categories",
      operator: "or",
    },
    {
      key: "vertical_sub_categories",
      operator: "or",
    },
    {
      key: "keywords",
      operator: "or",
    },
    {
      key: "social_media",
      operator: "or",
    },
    {
      key: "places",
      operator: "or",
    },
    {
      key: "exclude_places",
      operator: "or",
    },
    {
      key: "advertisement_target_locations",
      operator: "or",
    },
    {
      key: "advertisement_exclude_target_locations",
      operator: "or",
    },
    {
      key: "advertisement_search_terms",
      operator: "or",
    },
    {
      key: "contact_details",
      operator: "or",
    },
  ],
});

const state = {
  selected: getInitialFilterState(),

  savedSearchesPeopleFilter: {
    saved_search_name: "",
    is_ascending_order: false,
    is_personal: null,
  },
  savedSearchesCompanyFilter: {
    saved_search_name: "",
    is_ascending_order: false,
    is_personal: null,
  },
  savedSearchesIntentFilter: {
    saved_search_name: "",
    is_ascending_order: false,
    is_personal: null,
  },
  peopleSavedSearchesList: [],
  companySavedSearchesList: [],
  intentSavedSearchesList: [],
  checkedList: [],
  isShow: true,
  isLoading: false,
  searchCompanyList: [],
  total: {},
  companyExportFields: [],
  companySelectedModule: "",
  multipleSelectedListIds: [],
  savedList: {},
  sequenceList: {},
  selectedCompanies: new Map(),
  searchAbortController: null,
  currentRequestId: 0,

  compaines_saved_search_access_code: null,
  people_saved_search_access_code: null,
  intent_saved_search_access_code: null,

  companies_search_list_access_code: null,

  companies_detail_info_access_code: null,
  similiar_companies_access_code: null,
};

const getters = {
  apiPayload: (state, _, rootState) => {
    const { selected } = state;

    const payload = {
      ...selected,
      profile_id: rootState.user.currentId.profile_id,
      company_groups: selected.company_groups?.map((item) => item.value),
      companies: [...selected.companies.keys()],
      locations: [...selected.locations.keys()],
      technologies: selected.technologies?.map((item) => item.value),
      categories: selected.categories?.map((item) => item.value),
      verticals: selected.verticals?.map((item) => item.value),
      vertical_categories: selected.vertical_categories?.map(
        (item) => item.value,
      ),
      social_media: selected.social_media?.map((item) => item.value),
      sequences: selected.sequences?.map((item) => item.value),
      job_locations: [...selected.job_locations.keys()],
      job_exclude_locations: [...selected.job_exclude_locations.keys()],
      news_categories: selected.news_categories?.map((item) => item.value),
      vertical_sub_categories: selected.vertical_sub_categories?.map(
        (item) => item.value,
      ),
      exclude_locations: [...selected.exclude_locations.keys()],
      advertisement_target_locations: [
        ...selected.advertisement_target_locations.keys(),
      ],
      advertisement_exclude_target_locations: [
        ...selected.advertisement_exclude_target_locations.keys(),
      ],
      advertisement_platforms: selected.advertisement_platforms?.map(
        (i) => i.value,
      ),
      advertisement_status: selected.advertisement_status?.map((i) => i.value),
      places: selected.places,
      exclude_places: selected.exclude_places,
      filter_conditions: withoutUnsupportedJobLocationOperators(
        selected.filter_conditions,
      ),
      contact_details: contactDetailsPayload(selected.contact_details),
      page: selected.notReset ? selected.page : 1,
    };

    delete payload.notReset;
    if (!payload.contact_details) delete payload.contact_details;

    return payload;
  },
};

const mutations = {
  set_compaines_saved_search_access_code(state, payload) {
    state.compaines_saved_search_access_code = payload;
  },
  set_people_saved_search_access_code(state, payload) {
    state.people_saved_search_access_code = payload;
  },
  set_intent_saved_search_access_code(state, payload) {
    state.intent_saved_search_access_code = payload;
  },
  set_companies_search_list_access_code(state, payload) {
    state.companies_search_list_access_code = payload;
  },
  set_companies_detail_info_access_code(state, payload) {
    state.companies_detail_info_access_code = payload;
  },
  set_similiar_companies_access_code(state, payload) {
    state.similiar_companies_access_code = payload;
  },
  SET_FILTERS_FROM_PAYLOAD(state, payload) {
    state.selected = {
      ...getInitialFilterState(),
      ...state.selected,
      ...payload,
    };
  },

  UPDATE_FILTER(state, { dataKey, value }) {
    if (state.selected.hasOwnProperty(dataKey)) {
      state.selected[dataKey] = value;
      state.selected.page = 1;
      state.selected = { ...state.selected };
    }
  },

  UPSERT_TO_MAP_FILTER(state, { dataKey, item }) {
    if (state.selected[dataKey] instanceof Map) {
      state.selected[dataKey].set(item.value, item);
      state.selected.page = 1;
      state.selected = { ...state.selected };
    }
  },

  // Atomic replace for Map filters — one spread instead of N+1 when the
  // caller already has the full set in hand (see setLocations action).
  REPLACE_MAP_FILTER(state, { dataKey, map }) {
    if (state.selected.hasOwnProperty(dataKey) && map instanceof Map) {
      state.selected[dataKey] = map;
      state.selected.page = 1;
      state.selected = { ...state.selected };
    }
  },

  ADD_TO_ARRAY_FILTER(state, { dataKey, item }) {
    if (Array.isArray(state.selected[dataKey])) {
      const list = state.selected[dataKey];
      const exists = list.some((i) => i.value === item.value);
      if (!exists) {
        list.push(item);
        state.selected = { ...state.selected };
      }
    }
  },

  REMOVE_FROM_MAP_FILTER(state, { dataKey, itemValue }) {
    if (state.selected[dataKey] instanceof Map) {
      if (state.selected[dataKey].delete(itemValue)) {
        state.selected = { ...state.selected };
      }
    }
  },

  REMOVE_FROM_ARRAY_FILTER(state, { dataKey, itemValue }) {
    if (Array.isArray(state.selected[dataKey])) {
      const list = state.selected[dataKey];
      const index = list.findIndex((i) => i.value === itemValue);
      if (index > -1) {
        list.splice(index, 1);
        state.selected = { ...state.selected };
      }
    }
  },

  CLEAR_COMPOSITE_FILTER(state, dataKey) {
    if (dataKey === "industry") {
      state.selected.vertical_sub_categories = [];
      state.selected.vertical_categories = [];
    } else if (dataKey === "technology") {
      state.selected.technologies = [];
      state.selected.categories = [];
    } else if (dataKey === "news") {
      state.selected.news_categories = [];
      state.selected.news_published_dates = [];
    } else if (dataKey === "jobs") {
      state.selected.job_locations = new Map();
      state.selected.job_exclude_locations = new Map();
      state.selected.job_posted_dates = [];
      state.selected.job_titles = [];
      state.selected.exclude_job_titles = [];
    } else if (dataKey === "advertisement") {
      state.selected.advertisement_target_locations = new Map();
      state.selected.advertisement_exclude_target_locations = new Map();
      state.selected.advertisement_search_terms = [];
      state.selected.advertisement_platforms = [];
      state.selected.advertisement_status = [];
      state.selected.advertisement_start_dates = [];
      state.selected.advertisement_end_dates = [];
    } else if (dataKey === "locations") {
      state.selected.exclude_locations = new Map();
      state.selected.locations = new Map();
    } else if (dataKey === "places") {
      state.selected.places = [];
      state.selected.exclude_places = [];
    }
    state.selected = { ...state.selected };
  },

  RESET_ALL_FILTERS(state) {
    state.selected = getInitialFilterState();
  },

  setCompanySelectedModule(state, payload) {
    state.companySelectedModule = payload;
  },
  setCollapse(state) {
    state.isShow = !state.isShow;
  },
  setLoading(state, val) {
    state.isLoading = val;
  },
  setCheckedList(state, payload) {
    state.checkedList = payload;
  },
  setSavedList(state, payload) {
    state.savedList = payload;
  },
  setSequenceList(state, payload) {
    state.sequenceList = payload;
  },
  setIntentSavedSearchesFilter(state, payload) {
    state.savedSearchesIntentFilter = {
      ...this.savedSearchesIntentFilter,
      ...payload,
    };
  },
  setPeopleSavedSearchesFilter(state, payload) {
    state.savedSearchesPeopleFilter = {
      ...this.savedSearchesPeopleFilter,
      ...payload,
    };
  },
  setCompanySavedSearchesFilter(state, payload) {
    state.savedSearchesCompanyFilter = {
      ...this.savedSearchesCompanyFilter,
      ...payload,
    };
  },
  setCompanySavedSearchesList(state, savedList) {
    state.companySavedSearchesList = savedList;
  },
  setPeopleSavedSearchesList(state, savedList) {
    state.peopleSavedSearchesList = savedList;
  },
  setIntentSavedSearchesList(state, savedList) {
    state.intentSavedSearchesList = savedList;
  },
  setMultiAddSavedList(state, addedGroupInfo) {
    const ids = state.checkedList.map((item) => item.domain_search_id);
    state.searchCompanyList = state.searchCompanyList.map((item) => {
      if (ids.includes(item.domain_search_id)) {
        if (item.saved_lists) {
          const groupIds = item.saved_lists.map((group) => group.group_id);
          return groupIds.includes(addedGroupInfo.group_id)
            ? item
            : {
                ...item,
                saved_lists: [...item.saved_lists, addedGroupInfo],
              };
        } else {
          return {
            ...item,
            saved_lists: [addedGroupInfo],
          };
        }
      } else {
        return item;
      }
    });
  },
  setSelected(state, val) {
    const { notReset, ...rest } = val;
    let temp = {
      profile_id: this.state.user.currentId.profile_id,
      ...state.selected,
      ...rest,
      page: val.notReset ? val.page : 1,
    };
    state.selected = temp;
    const { profile_id, ...restParams } = temp;
  },
  setRowAddSavedList(state, payload) {
    const { domain_search_id, group } = payload;
    state.searchCompanyList = state.searchCompanyList.map((item) => {
      if (item.domain_search_id === domain_search_id) {
        if (item.saved_lists) {
          const groupIds = item.saved_lists.map(
            (groupItem) => groupItem.group_id,
          );
          return groupIds.includes(group.group_id)
            ? item
            : {
                ...item,
                saved_lists: [...item.saved_lists, group],
              };
        } else {
          return {
            ...item,
            saved_lists: [group],
          };
        }
      } else {
        return item;
      }
    });
  },
  setMultiDeleteSavedList(state, groupInfo) {
    const ids = state.checkedList.map((item) => item.domain_search_id);
    state.searchCompanyList = state.searchCompanyList.map((item) => {
      return ids.includes(item.domain_search_id)
        ? {
            ...item,
            saved_lists: item.saved_lists.filter(
              (groupItem) => groupItem.group_id !== groupInfo.groupId,
            ),
          }
        : item;
    });
  },
  setRowDeleteSavedList(state, payload) {
    const { domain_search_id, group } = payload;
    state.searchCompanyList = state.searchCompanyList.map((item) => {
      if (item.domain_search_id === domain_search_id) {
        return {
          ...item,
          saved_lists: item.saved_lists.filter(
            (groupItem) => groupItem.group_id !== group.group_id,
          ),
        };
      } else {
        return item;
      }
    });
  },
  setCompanyExportFields(state, payload) {
    state.companyExportFields = payload;
  },
  setSearchCompanyList(state, payload) {
    const data = payload?.data;
    if (!data) return;
    data.companies &&
      (state.searchCompanyList = data.companies?.map((item) => ({
        ...item,
        loading: false,
      })));
    data.pagination && (state.total = data.pagination);
  },
  setMultipleSelectedListIds(state, payload) {
    state.multipleSelectedListIds = payload;
  },
  setSelectedCompanies(state, payload) {
    state.selectedCompanies = payload;
  },
  setSearchAbortController(state, controller) {
    state.searchAbortController = controller;
  },
  setRequestId(state, payload) {
    state.currentRequestId = payload;
  },
};

const actions = {
  /*----------------【重构】筛选器相关的 Actions-----------------*/

  async searchCompanyList({ commit, state, getters }) {
    if (getIsAccessDisabled(state.companies_search_list_access_code)) {
      return;
    }
    const requestId = state.currentRequestId + 1;
    commit("setRequestId", requestId);

    if (state.searchAbortController) {
      state.searchAbortController.abort();
    }
    const controller = new AbortController();
    commit("setSearchAbortController", controller);

    const apiPayload = getters.apiPayload;

    const paramsEmpty = (params) => {
      let allEmpty = true;
      Object.keys(params).forEach((item) => {
        if (["page", "per_page", "search_modes", "hash"].includes(item)) return;
        if (item === "contact_details") {
          if (isContactDetailsActive(params[item])) allEmpty = false;
          return;
        }
        if (
          (Array.isArray(params[item]) && params[item].length > 0) ||
          (typeof params[item] === "string" && !!params[item]) ||
          (params[item] instanceof Map && params[item].size > 0)
        ) {
          allEmpty = false;
        }
      });
      return allEmpty;
    };

    if (paramsEmpty(apiPayload)) {
      commit("setSearchCompanyList", {
        data: { companies: [], pagination: {} },
      });
      router.push({ name: "company" });
      return;
    }

    try {
      commit("setLoading", true);
      const result = await ComObj.searchCompanyList(
        apiPayload,
        controller.signal,
      );
      if (result && state.currentRequestId === requestId) {
        commit("setSearchCompanyList", result);
        result?.metadata?.recent_search_log_identifier &&
          router.push({
            name: "company",
            query: {
              recent_search_log_identifier:
                result?.metadata?.recent_search_log_identifier,
            },
          });
        return result;
      }
    } catch (err) {
      const code = err?.response?.data?.code;
      commit("set_companies_search_list_access_code", +code);
      if (err.code === "ERR_CANCELED") {
      }
    } finally {
      if (state.currentRequestId === requestId) {
        commit("setLoading", false);
      }
    }
  },

  updateFilter({ commit }, payload) {
    // payload: { dataKey, value }
    commit("UPDATE_FILTER", payload);
  },

  clearFilterGroup({ commit }, dataKey) {
    if (
      [
        "industry",
        "technology",
        "news",
        "jobs",
        "locations",
        "advertisement",
        "places"
      ].includes(dataKey)
    ) {
      commit("CLEAR_COMPOSITE_FILTER", dataKey);
    } else {
      const initialValue = getInitialFilterState()[dataKey];
      commit("UPDATE_FILTER", { dataKey, value: initialValue });
    }
  },

  clearAllFilters({ commit }) {
    commit("RESET_ALL_FILTERS");
  },

  // items: [{ value, label }] — replaces the locations Map atomically.
  setLocations({ commit }, items = []) {
    const map = new Map(items.map((item) => [item.value, item]));
    commit("REPLACE_MAP_FILTER", { dataKey: "locations", map });
  },

  /*---------------- 原有的、与筛选器无关的 Actions 保持不变 -----------------*/
  async addCompanyToGroup(context, val) {
    try {
      await ComObj.addCompany(val);
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async deleteCompany(context, val) {
    try {
      const result = await ComObj.deleteCompany({
        ...val,
        profile_id: this.state.user.currentId.profile_id,
      });
      return result?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async getCompanyDetail(context, data) {
    try {
      const result = await ComObj.getCompanyDetail(data);
      return result?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async getDomainIdByGroup(context, data) {
    try {
      const result = await ComObj.getDomainIdByGroup({
        ...data,
        profile_id: this.state.user.currentId.profile_id,
      });
      return result?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  /*---------------export------------------*/
  async export(context, data) {
    try {
      const result = await ComObj.exportCompany({
        ...data,
        profile_id: this.state.user.currentId.profile_id,
      });
      return result;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async getSaveSearchesList(context, data) {
    try {
      const { search_type_id } = data;
      let access_code = null;
      switch (search_type_id) {
        case 1:
          access_code = context.state.compaines_saved_search_access_code;
          break;
        case 2:
          access_code = context.state.people_saved_search_access_code;
          break;
        case 3:
          access_code = context.state.intent_saved_search_access_code;
          break;
      }
      if (getIsAccessDisabled(access_code)) {
        return;
      }
      const result = await ComObj.getSaveList({
        profile_id: this.state.user.currentId.profile_id,
        ...data,
      });
      if (search_type_id === 1) {
        context.commit(
          "setCompanySavedSearchesList",
          result.data ? result.data : [],
        );
      } else if (search_type_id === 2) {
        context.commit(
          "setPeopleSavedSearchesList",
          result.data ? result.data : [],
        );
      } else if (search_type_id === 3) {
        context.commit(
          "setIntentSavedSearchesList",
          result.data ? result.data : [],
        );
      }
      return result?.data || [];
    } catch (error) {
      const { search_type_id } = data;
      const code = error?.response?.data?.code;

      switch (search_type_id) {
        case 1:
          context.commit("set_compaines_saved_search_access_code", +code);
          break;
        case 2:
          context.commit("set_people_saved_search_access_code", +code);
          break;
        case 3:
          context.commit("set_intent_saved_search_access_code", +code);
          break;
      }
      throw error;
    }
  },
  async addSaveList(context, data) {
    try {
      let type =
        data?.search_type_id === 1
          ? this.state.company.selected
          : this.state.people.selected;
      let params = data?.params ? data?.params : type;
      await ComObj.addSaveList({
        profile_id: this.state.user.currentId.profile_id,
        saved_search_name: data?.saved_search_name,
        is_personal: data?.is_personal,
        search_type_id: data?.search_type_id,
        is_pinned: data?.is_pinned,
        parameters: params,
      });
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async updateSaveList(context, data) {
    try {
      let payload = {};
      if (data?.params) {
        payload = {
          profile_id: this.state.user.currentId.profile_id,
          saved_searches: data?.saved_searches,
          saved_search_name: data?.saved_search_name,
          is_personal: data?.is_personal,
          is_pinned: data?.is_pinned,
          parameters: data?.params,
        };
      } else {
        payload = {
          profile_id: this.state.user.currentId.profile_id,
          saved_searches: data?.saved_searches,
          saved_search_name: data?.saved_search_name,
          is_personal: data?.is_personal,
          is_pinned: data?.is_pinned,
          parameters:
            data?.search_type_id === 1
              ? this.state.company.selected
              : this.state.people.selected,
        };
      }
      let result = await ComObj.updateSaveList(payload);
      return result?.data;
    } catch (err) {
      console.log(err);
      throw err;
    }
  },
  async getRecentSearches({ commit }, search_type_id) {
    try {
      const result = await ComObj.getRecentSearchesList({
        profile_id: this.state.user.currentId.profile_id,
        search_type_id,
      });
      return result.data;
    } catch (error) {}
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
